import {AgentName} from 'common/src/modules/shared/copilot/copilot.enums';
import {Agent} from 'common/src/modules/shared/copilot/copilot.types';
import agent from 'common/src/modules/shared/copilot/utils/creators/agent';
import {CLStore} from 'common/src/redux/store';
import campaignContext from '../contexts/campaignContext';
import {CampaignToolName} from '../copilotCampaigns.enums';
import {briefSchema} from '../copilotCampaigns.schemas';
import createAudienceTool from '../tools/createAudienceTool';

function briefAgent(store: CLStore): Agent {
  const inScope = [
    `Discuss, fill, and update a campaign brief, which consists of the following fields: ${Object.keys(briefSchema.shape).join(', ')}`,
  ];

  const outOfScope = ['Build a strategy', 'Build a decision tree', 'Create a new campaign'];

  const role = 'You help users fill in a campaign brief.';

  const instructions = `### Steps for filling in a campaign brief

1. Get the current brief from the 'CONTEXT', which also contains a list of empty brief fields.
2. Analyze the user's request. Ignore anything unrelated to the brief fields.
   2.1 If the request indicates specific brief fields to update, update them and end the session.
   2.2 Otherwise, ask the user to fill in the first empty field in the brief - one field at a time. If there are no empty fields in the brief, notify the user that all fields are filled and ask whether they want to change anything.
   Empty fields can be updated in any order, if the user wishes to edit/change/update them.
3. If the user wants to add a new audience to the brief, use the '${CampaignToolName.CreateAudience}' tool.

### General instructions
- If the user attempts to edit one of these uneditable fields, inform the user that these fields cannot be edited:
  - strategySummary
  - creativeInstructions
  - feedInstructions
- **Always** use the latest CONTEXT to infer the most up to date brief.
- Never suggest to fill any other property other than the ones in the schema.
- On each step, ALWAYS save the campaign brief changes with the '${CampaignToolName.SaveBrief}' tool.`;

  // required tools for this agent
  const uiToolNames = [CampaignToolName.SaveBrief];

  // the tools that are ready from the start, on this agent
  const tools = [createAudienceTool()];

  const contexts = [campaignContext(store)];

  return agent({
    name: AgentName.Brief,
    role,
    store,
    inScope,
    outOfScope,
    instructions,
    tools,
    uiToolNames,
    contexts,
  });
}

export default briefAgent;
